import { TLink } from "@/components/molecules/Button";
import { Container } from "@/components/molecules/Container";
import { LogoType } from "@/components/molecules/logos/LogoType";
import { faArrowUpLong } from "@fortawesome/pro-thin-svg-icons";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import Link from "next/link";
import { FaFacebook, FaInstagram } from "react-icons/fa";

const sns = [
  {
    name: "X",
    href: "https://x.com/toccasystems",
    icon: () => (
      <svg width="20" height="20" viewBox="0 0 1200 1227" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/toccasystems/",
    icon: FaInstagram,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/toccasystems/",
    icon: FaFacebook,
  },
];
const globalNavi = [
  { name: "About", href: "/about" },
  { name: "Service", href: "/service" },
  { name: "Product", href: "/product" },
  { name: "Project", href: "/project" },
  { name: "Event", href: "/event" },
  { name: "News", href: "/news" },
  { name: "Identity", href: "/identity" },
  { name: "Careers", href: "/careers" },
  { name: "AI Maturity", href: "/shindan?from=footer" },
  { name: "Contact", href: "/contact" },
];
const externalNavi = [
  { name: "Solution", href: "https://solution.tocca.systems/", isExternal: true },
];
const subNavi2 = [
  { name: "プライバシー・ポリシー", href: "/policy" },
  { name: "TWP プライバシーポリシー", href: "/twp/privacy" },
  { name: "サイトのご利用について", href: "/terms" },
  { name: "商取引法に基づく表記", href: "/legal" },
  { name: "ISMS基本方針", href: "/isms" },
  { name: "QMS基本方針", href: "/qms" },
  { name: "AI活用方針", href: "/ai_policy" },
];

export function Footer({ className }) {
  return (
    <footer
      className={clsx(className, "bg-nvy 2xs:py-10 xs:py-10 md:py-16 lg:py-24")}
    >
      <Container className="px-6 sm:px-8 md:px-12">
        <div className="relative z-20 mx-auto max-w-7xl items-start justify-start">
          <h1 className="w-max">
            <Link href="/">
              <a className="flex min-h-full items-center justify-center">
                <span className="sr-only">Home</span>
                <LogoType className="h-[22px] w-auto brightness-1000 md:h-[28px] lg:h-[32px]" />
              </a>
            </Link>
          </h1>
          <div className="relative mt-7 flex flex-col 2xs:gap-4 xs:gap-6 md:gap-4 lg:mt-10 lg:gap-5">
                        <ul className="flex list-none flex-wrap items-center justify-start gap-x-4 gap-y-1 md:gap-5 lg:gap-5">
                          {globalNavi.map((item) => (
                            <li key={item.name}>
                              <TLink
                                href={item.href}
                                variant="dark"
                                color="f"
                                className="fluid-text-[16px,18px]"
                              >
                                {item.name}
                              </TLink>
                            </li>
                          ))}
                          {externalNavi.map((item) => (
                            <li key={item.name}>
                              <a
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-1 font-bold text-white hover:text-hov fluid-text-[16px,18px]"
                              >
                                {item.name}
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                              </a>
                            </li>
                          ))}
                        </ul>
                        {/* TWP（自社プロダクト）は他のナビ項目に混ぜず、独立した行で目立たせる（2026-08） */}
                        <div className="w-max">
                          <a
                            href="https://twp-saas.tocca.systems/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-2 rounded-md border border-white/40 px-4 py-2 font-bold text-white transition-colors hover:border-pri hover:text-hov fluid-text-[14px,18px]"
                          >
                            <span>
                              TWP
                              <span className="ml-2 font-normal fluid-text-[12px,14px]">
                                Tocca Working Platform
                              </span>
                            </span>
                            <FontAwesomeIcon
                              icon={faArrowUpRightFromSquare}
                              className="text-xs"
                            />
                          </a>
                        </div>
            <ul className="flex list-none flex-wrap items-center justify-start gap-x-3 gap-y-1 md:gap-5 lg:gap-5">
              {subNavi2.map((item) => (
                <li key={item.name}>
                  <TLink
                    href={item.href}
                    variant="dark"
                    color="f"
                    className="fluid-text-[12px,16px]"
                  >
                    {item.name}
                  </TLink>
                </li>
              ))}
            </ul>
            <ul className="flex list-none flex-wrap items-center justify-start gap-x-3 gap-y-2 md:-ml-2 md:gap-3 lg:-ml-2 lg:gap-5">
              {sns.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    target="_blank"
                    className=" flex items-center rounded-full hover:bg-gray-50"
                    rel="noreferrer"
                  >
                    <p className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-icn hover:text-hov md:h-10 md:w-10 lg:h-10 lg:w-10">
                      <item.icon
                        className="h-6 w-6 lg:h-6 lg:w-6"
                        aria-hidden="true"
                      />
                    </p>
                  </a>
                </li>
              ))}
            </ul>
            <ul className="flex list-none flex-col items-start justify-start gap-2 md:gap-2 lg:mt-4 lg:gap-1">
              <li>
                <TLink
                  href="https://goo.gl/maps/QCfjpiCLH5BptRdE6"
                  variant="dark"
                  color="pp"
                  className="w-full rounded-md fluid-text-[14px,16px]"
                  target="_blank"
                  rel="noreferrer"
                >
                  101-0051
                  <br />
                  東京都千代田区神田神保町2-20 ワカヤギビル3階
                </TLink>
              </li>
              <li className="text-white">
                tel:&nbsp;
                <a
                  href="tel:03-5213-4278"
                  className="text-white fluid-text-[14px,16px] hover:text-hov"
                >
                  03-5213-4278
                </a>
              </li>
              <li className="lg:mt-8">
                <h6 className="tracking-wider text-white fluid-text-[11px,11px]">
                  ©&nbsp;ToccaSystems Co., Ltd. All Rights Reserved.
                </h6>
              </li>
            </ul>
            <div className="relative m-auto md:absolute md:right-8 md:bottom-0 lg:absolute lg:right-0 lg:bottom-4">
              <Link href="#">
                <a className="text-2xl font-bold text-white hover:text-hov lg:text-4xl">
                  <FontAwesomeIcon icon={faArrowUpLong} />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
